import * as React from 'react';

const CloseIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M15.9498 15.95L6.0498 6.05005M6.0498 15.95L15.9498 6.05005"
      stroke="black"
      strokeWidth="2.0625"
      strokeLinecap="round"
    />
  </svg>
);

export default CloseIcon;
